// What `table_number` actually holds, in one place.
//
// `transactions.table_number` is an OVERLOADED column carrying three different
// things, distinguished only by convention:
//
//   "4"          a real table number         -> "Table: 4"
//   "#019"       the daily order counter     -> "Order: #019"
//   "Jane Doe"   an employee, on a staff meal -> "Staff: Jane Doe"
//
// The leading "#" is the whole mechanism, and `dining_option` distinguishes the
// staff case. This has now been re-implemented independently four times — the
// two backend renderers (item 23), the browser receipt renderer (item 28) and
// the refund modal's new sale summary — and got it wrong in three of them. The
// refund modal labelled a takeaway's "#021" as "Table Number #021".
//
// So this module exports the DECISION, not the label. Callers map the kind to
// their own text: the printed receipt uses English literals because the backend
// renderers do, the UI runs it through t(). Sharing the wording instead would
// force one surface to adopt the other's, which is why it was never shared.
//
// Mirrors `_table_label` and `is_staff_meal` in
// backend/app/services/receipt_renderer.py; the two must agree, since a tenant
// hits either this HTML path or a backend renderer.

export const STAFF_MEAL_DINING_OPTION = 'staff allowance';

/**
 * Which of the three things this `table_number` is.
 *
 * @returns {'staff'|'order'|'table'}
 */
export function tableSlotKind(tableNumber, diningOption) {
    if (String(diningOption || '').trim().toLowerCase() === STAFF_MEAL_DINING_OPTION) {
        return 'staff';
    }
    return String(tableNumber || '').startsWith('#') ? 'order' : 'table';
}

export default tableSlotKind;
